import { render, staticRenderFns } from "./FileTitle.vue?vue&type=template&id=077f9a6a&scoped=true&"
import script from "./FileTitle.vue?vue&type=script&lang=js&"
export * from "./FileTitle.vue?vue&type=script&lang=js&"
import style0 from "./FileTitle.vue?vue&type=style&index=0&id=077f9a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f9a6a",
  null
  
)

component.options.__file = "FileTitle.vue"
export default component.exports